/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthCallbackRouteImport } from './routes/auth-callback'
import { Route as MigrationStatusIndexRouteImport } from './routes/migration-status/index'
import { Route as MigrationReportIndexRouteImport } from './routes/migration-report/index'
import { Route as FormdataIndexRouteImport } from './routes/formdata/index'
import { Route as FormdataInjectorIndexRouteImport } from './routes/formdata-injector/index'
import { Route as BackofficeUsersIndexRouteImport } from './routes/backoffice-users/index'
import { Route as UsersIdIndexRouteImport } from './routes/users/$id/index'
import { Route as BackofficeUsersAddIndexRouteImport } from './routes/backoffice-users/add/index'
import { Route as AccountIdIndexRouteImport } from './routes/account/$id/index'
import { Route as UsersIdNotificationsIndexRouteImport } from './routes/users/$id/notifications/index'
import { Route as AccountIdNotificationsIndexRouteImport } from './routes/account/$id/notifications/index'

const IndexLazyRouteImport = createFileRoute('/')()

const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth-callback',
  path: '/auth-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const MigrationStatusIndexRoute = MigrationStatusIndexRouteImport.update({
  id: '/migration-status/',
  path: '/migration-status/',
  getParentRoute: () => rootRouteImport,
} as any)
const MigrationReportIndexRoute = MigrationReportIndexRouteImport.update({
  id: '/migration-report/',
  path: '/migration-report/',
  getParentRoute: () => rootRouteImport,
} as any)
const FormdataIndexRoute = FormdataIndexRouteImport.update({
  id: '/formdata/',
  path: '/formdata/',
  getParentRoute: () => rootRouteImport,
} as any)
const FormdataInjectorIndexRoute = FormdataInjectorIndexRouteImport.update({
  id: '/formdata-injector/',
  path: '/formdata-injector/',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeUsersIndexRoute = BackofficeUsersIndexRouteImport.update({
  id: '/backoffice-users/',
  path: '/backoffice-users/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIdIndexRoute = UsersIdIndexRouteImport.update({
  id: '/users/$id/',
  path: '/users/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeUsersAddIndexRoute = BackofficeUsersAddIndexRouteImport.update({
  id: '/backoffice-users/add/',
  path: '/backoffice-users/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIdIndexRoute = AccountIdIndexRouteImport.update({
  id: '/account/$id/',
  path: '/account/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIdNotificationsIndexRoute =
  UsersIdNotificationsIndexRouteImport.update({
    id: '/users/$id/notifications/',
    path: '/users/$id/notifications/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountIdNotificationsIndexRoute =
  AccountIdNotificationsIndexRouteImport.update({
    id: '/account/$id/notifications/',
    path: '/account/$id/notifications/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/auth-callback': typeof AuthCallbackRoute
  '/backoffice-users': typeof BackofficeUsersIndexRoute
  '/formdata-injector': typeof FormdataInjectorIndexRoute
  '/formdata': typeof FormdataIndexRoute
  '/migration-report': typeof MigrationReportIndexRoute
  '/migration-status': typeof MigrationStatusIndexRoute
  '/account/$id': typeof AccountIdIndexRoute
  '/backoffice-users/add': typeof BackofficeUsersAddIndexRoute
  '/users/$id': typeof UsersIdIndexRoute
  '/account/$id/notifications': typeof AccountIdNotificationsIndexRoute
  '/users/$id/notifications': typeof UsersIdNotificationsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/auth-callback': typeof AuthCallbackRoute
  '/backoffice-users': typeof BackofficeUsersIndexRoute
  '/formdata-injector': typeof FormdataInjectorIndexRoute
  '/formdata': typeof FormdataIndexRoute
  '/migration-report': typeof MigrationReportIndexRoute
  '/migration-status': typeof MigrationStatusIndexRoute
  '/account/$id': typeof AccountIdIndexRoute
  '/backoffice-users/add': typeof BackofficeUsersAddIndexRoute
  '/users/$id': typeof UsersIdIndexRoute
  '/account/$id/notifications': typeof AccountIdNotificationsIndexRoute
  '/users/$id/notifications': typeof UsersIdNotificationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/auth-callback': typeof AuthCallbackRoute
  '/backoffice-users/': typeof BackofficeUsersIndexRoute
  '/formdata-injector/': typeof FormdataInjectorIndexRoute
  '/formdata/': typeof FormdataIndexRoute
  '/migration-report/': typeof MigrationReportIndexRoute
  '/migration-status/': typeof MigrationStatusIndexRoute
  '/account/$id/': typeof AccountIdIndexRoute
  '/backoffice-users/add/': typeof BackofficeUsersAddIndexRoute
  '/users/$id/': typeof UsersIdIndexRoute
  '/account/$id/notifications/': typeof AccountIdNotificationsIndexRoute
  '/users/$id/notifications/': typeof UsersIdNotificationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-callback'
    | '/backoffice-users'
    | '/formdata-injector'
    | '/formdata'
    | '/migration-report'
    | '/migration-status'
    | '/account/$id'
    | '/backoffice-users/add'
    | '/users/$id'
    | '/account/$id/notifications'
    | '/users/$id/notifications'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-callback'
    | '/backoffice-users'
    | '/formdata-injector'
    | '/formdata'
    | '/migration-report'
    | '/migration-status'
    | '/account/$id'
    | '/backoffice-users/add'
    | '/users/$id'
    | '/account/$id/notifications'
    | '/users/$id/notifications'
  id:
    | '__root__'
    | '/'
    | '/auth-callback'
    | '/backoffice-users/'
    | '/formdata-injector/'
    | '/formdata/'
    | '/migration-report/'
    | '/migration-status/'
    | '/account/$id/'
    | '/backoffice-users/add/'
    | '/users/$id/'
    | '/account/$id/notifications/'
    | '/users/$id/notifications/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BackofficeUsersIndexRoute: typeof BackofficeUsersIndexRoute
  FormdataInjectorIndexRoute: typeof FormdataInjectorIndexRoute
  FormdataIndexRoute: typeof FormdataIndexRoute
  MigrationReportIndexRoute: typeof MigrationReportIndexRoute
  MigrationStatusIndexRoute: typeof MigrationStatusIndexRoute
  AccountIdIndexRoute: typeof AccountIdIndexRoute
  BackofficeUsersAddIndexRoute: typeof BackofficeUsersAddIndexRoute
  UsersIdIndexRoute: typeof UsersIdIndexRoute
  AccountIdNotificationsIndexRoute: typeof AccountIdNotificationsIndexRoute
  UsersIdNotificationsIndexRoute: typeof UsersIdNotificationsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth-callback': {
      id: '/auth-callback'
      path: '/auth-callback'
      fullPath: '/auth-callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migration-status/': {
      id: '/migration-status/'
      path: '/migration-status'
      fullPath: '/migration-status'
      preLoaderRoute: typeof MigrationStatusIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migration-report/': {
      id: '/migration-report/'
      path: '/migration-report'
      fullPath: '/migration-report'
      preLoaderRoute: typeof MigrationReportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/formdata/': {
      id: '/formdata/'
      path: '/formdata'
      fullPath: '/formdata'
      preLoaderRoute: typeof FormdataIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/formdata-injector/': {
      id: '/formdata-injector/'
      path: '/formdata-injector'
      fullPath: '/formdata-injector'
      preLoaderRoute: typeof FormdataInjectorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backoffice-users/': {
      id: '/backoffice-users/'
      path: '/backoffice-users'
      fullPath: '/backoffice-users'
      preLoaderRoute: typeof BackofficeUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$id/': {
      id: '/users/$id/'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backoffice-users/add/': {
      id: '/backoffice-users/add/'
      path: '/backoffice-users/add'
      fullPath: '/backoffice-users/add'
      preLoaderRoute: typeof BackofficeUsersAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/$id/': {
      id: '/account/$id/'
      path: '/account/$id'
      fullPath: '/account/$id'
      preLoaderRoute: typeof AccountIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$id/notifications/': {
      id: '/users/$id/notifications/'
      path: '/users/$id/notifications'
      fullPath: '/users/$id/notifications'
      preLoaderRoute: typeof UsersIdNotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/$id/notifications/': {
      id: '/account/$id/notifications/'
      path: '/account/$id/notifications'
      fullPath: '/account/$id/notifications'
      preLoaderRoute: typeof AccountIdNotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BackofficeUsersIndexRoute: BackofficeUsersIndexRoute,
  FormdataInjectorIndexRoute: FormdataInjectorIndexRoute,
  FormdataIndexRoute: FormdataIndexRoute,
  MigrationReportIndexRoute: MigrationReportIndexRoute,
  MigrationStatusIndexRoute: MigrationStatusIndexRoute,
  AccountIdIndexRoute: AccountIdIndexRoute,
  BackofficeUsersAddIndexRoute: BackofficeUsersAddIndexRoute,
  UsersIdIndexRoute: UsersIdIndexRoute,
  AccountIdNotificationsIndexRoute: AccountIdNotificationsIndexRoute,
  UsersIdNotificationsIndexRoute: UsersIdNotificationsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
